export const SUNRUN_SPACE = 'iqf66370jqri';

export enum Environment {
  PROD = 'prd',
  MAJSTG = 'majstg',
  DEVMAJ = 'devmaj',
  LOCAL = 'local',
}

export const DYNAMIC_GRID_ARTICLE_LIMIT = 6;
export const DYNAMIC_SPLIT_ARTICLE_LIMIT = 4;

export enum SolarEcommHomepageEntries {
  HOMEPAGE_SUNRUN_SPACE_FOOTER = '4BLKH4utlRjsQDB0dU7bK4',
  HOMEPAGE_SUNRUN_SPACE_EMAIL_CAPTURE = '1tZtB55nxT0Ji0Rr0OHcsF',
}

export enum SolarEcommPageEntries {
  FIRST_STEP = '3zjzzPLjYwqwOgJX1HcWV8',
  SECOND_STEP = '5KFiWVpsmvCq1mjAsuJ6Eu',
  CONFIRMATION_STEP = '6bCAHwg3uWSTzYr94QfU33',
}

export enum PublicBatteryEcommPageEntries {
  LANDING = '5QKiR59yLZg8nT49xyFKzC',
  QUOTE = '4wRwkb7ysbYqMGa5T3Ng6U',
  CONFIRMATION = 'Bzs4KC6qersrMKqSnDFfL',
  OUT_OF_SERVICE = 'uQR38v2OV98bB3cPhXL2x',
  CONTACT = 'a0q0U4cL9ZXzA34jUT04I',
}

export enum SolarQuoteEcommPageEntries {
  QUOTE = '6EKa4YAeTBP8ZCBKZk3riB',
  CONTACT = '4GhZISZN09RCh6qqzmlnq2',
  CONFIRMATION = '22hAE4UsB0Zhzj3PN4roLj',
  LOGIN = '39cpABa9lY1F3P9zQfU8xM',
}

export const GQL_CONTENTFUL_URL = `https://graphql.contentful.com/content/v1/spaces/${SUNRUN_SPACE}/environments/master`;
